import React from "react";
import PlanItem from "../components/PlanItem";
import UserPromeItem from "../components/UserPromeItem";
import GridList from '@material-ui/core/GridList';
import GridContainer from "../../components/Grid/GridContainer";
import {withStyles} from "@material-ui/core";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import UserInvitationItem from "../components/UserInvitationItem";
import {getUserInvitation} from "../../utils/request";
import LoadingCard from "../components/LoadingCard";
import GridItem from "../../components/Grid/GridItem";
import intl from "react-intl-universal";


class AccountProme extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			promes: this.props.promes,
			users: this.props.users
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({promes: nextProps.promes});
		this.setState({users: nextProps.users});
	}


	render() {
		const {classes} = this.props;
		const promes = this.state.promes.map(data => {
			return <UserPromeItem
				data={data}
			/>
		});
		const invitation = this.state.users.map(data => {
			return <UserInvitationItem
				data={data}
			/>
		});
		return (
			<div>
				{/*<div className={classes.title}>*/}
				{/*	<h4>{intl.get('prome')}: </h4>*/}
				{/*</div>*/}
				{/*{*/}
				{/*	this.state.promes.length === 0 ?*/}
				{/*		<GridContainer>*/}
				{/*			<GridItem  xs={12} sm={4} md={4} lg={4}>*/}
				{/*				<LoadingCard type={4}/>*/}
				{/*			</GridItem>*/}
				{/*			<GridItem  xs={12} sm={8} md={8} lg={8}>*/}
				{/*				<h5>*/}
				{/*					{intl.get('prome_get')}<br/>*/}
				{/*				</h5>*/}
				{/*				<h6>*/}
				{/*					• {intl.get('prome_get_1')}<br/>*/}
				{/*					• {intl.get('prome_get_2')}*/}
				{/*				</h6>*/}
				{/*			</GridItem>*/}
				{/*		</GridContainer>*/}
				{/*		:*/}
				{/*		<GridList*/}
				{/*			style={{*/}
				{/*				flexWrap: 'nowrap',*/}
				{/*				transform: 'translateZ(0)',*/}
				{/*				marginTop: '-48px'*/}
				{/*			}} cols={2.5}>*/}
				{/*			{promes}*/}
				{/*		</GridList>*/}
				{/*}*/}


				<div className={classes.title}>
					<h4>{intl.get('invi_friend')}: </h4>
				</div>

				{
					this.state.users.length === 0 ?
						<GridContainer>
							<GridItem  xs={12} sm={4} md={4} lg={4}>
								<LoadingCard type={4}/>
							</GridItem>
							<GridItem  xs={12} sm={8} md={8} lg={8}>
								<h5>
									{intl.get('invi_get')}<br/>
								</h5>
								<h6>
									• {intl.get('invi_get_1')}<br/>
									• {intl.get('invi_get_2')}
								</h6>
							</GridItem>
						</GridContainer>
						:
						<GridContainer>
							{invitation}
						</GridContainer>
				}

			</div>

		);
	}
}

export default withStyles(styles)(AccountProme)